import { createAppSlice } from 'app/createAppSlice'
import moment from 'moment-timezone'

const initialState = {
  tag: {
    month: moment().month() + 1,
    year: moment().format('YYYY'),
    selectedMonthYear: new Date(),
    group: 'All',
  },
  loading: false,
}

export const findoraDashboardListSlice = createAppSlice({
  name: 'findoraDashboardList',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
    setLoading: create.reducer((state, { payload }) => {
      state.loading = payload
    }),
  }),
})

export const { setFetchOption, setLoading } = findoraDashboardListSlice.actions

export default findoraDashboardListSlice.reducer
